import { render, staticRenderFns } from "./ClientTableElement.vue?vue&type=template&id=618701e6&scoped=true"
import script from "./ClientTableElement.vue?vue&type=script&lang=ts"
export * from "./ClientTableElement.vue?vue&type=script&lang=ts"
import style0 from "./ClientTableElement.vue?vue&type=style&index=0&id=618701e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618701e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})
